import { runBackgroundJobs } from './background_job.js'
import { forwardCall, forwardCallByName } from './forward_call.js'
import { Auth, isAuthError } from './middlewares/auth.js'
import CacheWrapper from './middlewares/cache_wrapper.js'
import Normalization from './middlewares/normalization.js'
import { SimplePermissionControl } from './middlewares/permission.js'
import { RateLimit } from './middlewares/rate_limit.js'
import { requestLog } from './middlewares/request_log.js'
import utils from './utils/index.js'

export const wrappers = {
  Normalization,
  requestLog,
  SimplePermissionControl,
  CacheWrapper,
  Auth,
  RateLimit,
}

// Prefer callByName() over direct public key calls
export const commonWorkers = {
  user_data_worker: '242ac5e2bbb305ab8d41a097b2366a306aec46450dd72070d6a4c12d6d9f8538',
  user_auth_worker: 'da24247510d812babb574fd91f4e87f75dc3bb7e65d1840094427774190c157b',
}

export { defaultSandbox } from './defaults.js'
export { runBackgroundJobs, utils, forwardCall, forwardCallByName, isAuthError }

interface CtxLike {
  auth_info?: { sub?: string; [k: string]: unknown }
  request?: { public_key?: string; [k: string]: unknown }
  [k: string]: unknown
}

/**
 * Extract user ID from request context
 */
export const getUserId = (ctx: CtxLike): string | null => {
  if (ctx.auth_info?.sub) return ctx.auth_info.sub
  if (ctx.request?.public_key) return ctx.request.public_key
  return null
}

// Client factory functions for unified initialization
export {
  createWorkerClient,
  createFrontendClient,
  generateEphemeralPrivateKey,
  CHANNEL_SERVICE_URL,
  CHANNEL_WEBSOCKET_URL,
  NAMESPACE_SERVICE_URL,
} from './client_factory.js'
